<template lang="html">
  <div class="hours-display">
    <v-row>
      <v-col :xs="12" :sm="6" :md="6" :lg="3">
        <v-text tag="div" class="hours-display-col">
          <v-text tag="h2">{{ contract.total_hours }}</v-text>
          <span> horas <br />estimadas </span>
          <v-helper class="text-muted" title="Horas estimadas" placement="top">
            Horas que foram estimadas no contrato inicial e posteriores adendos.
          </v-helper>
        </v-text>
      </v-col>
      <v-col :xs="12" :sm="6" :md="6" :lg="3">
        <v-text tag="div" class="hours-display-col">
          <v-text tag="h2">{{ contract.release_hours }}</v-text>
          <span> horas <br />liberadas </span>
          <v-helper class="text-muted" title="Horas liberadas" placement="top">
            Horas que foram liberadas para trabalho mediante compra de créditos.
          </v-helper>
        </v-text>
      </v-col>
      <v-col :xs="12" :sm="6" :md="6" :lg="3">
        <v-text tag="div" class="hours-display-col">
          <v-text tag="h2">{{ contract.hour_balance }}</v-text>
          <span> horas <br />pendentes </span>
          <v-helper class="text-muted" title="Horas pendentes" placement="top">
            Total de horas das liberadas que o Profissional ainda tem em aberto
            para cumprir.
          </v-helper>
        </v-text>
      </v-col>
      <v-col :xs="12" :sm="6" :md="6" :lg="3">
        <v-text tag="div" class="hours-display-col">
          <v-text tag="h2">{{ contract.work_hours }}</v-text>
          <span> horas <br />trabalhadas </span>
          <v-helper
            class="text-muted"
            title="Horas trabalhadas"
            placement="top"
          >
            Total de horas trabalhadas pelo Profissional.
          </v-helper>
        </v-text>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    contract: {},
  },
};
</script>

<style lang="scss">
.hours-display {
  .hours-display-col {
    display: flex;
    flex-direction: column;
    padding: 20px;
    text-align: center;
  }
  h2 {
    color: color(primary);
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/hours-display.vue